import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from '../ui/button';

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Presence', path: '/presence' },
    { name: 'Careers', path: '/careers' },
    { name: 'Contact', path: '/contact' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Top Bar */}
      <div className="bg-navy text-white py-3 hidden md:block">
        <div className="container mx-auto px-6 flex justify-between items-center">
          <div className="flex items-center gap-6 text-sm">
            <a href="tel:8788534309" className="flex items-center gap-2 hover:text-gold transition-colors">
              <Phone size={16} />
              <span>87885 34309</span>
            </a>
            <a href="mailto:office@cadpsarda.com" className="flex items-center gap-2 hover:text-gold transition-colors">
              <Mail size={16} />
              <span>office@cadpsarda.com</span>
            </a>
          </div>
          <div className="text-sm font-medium text-gold">
            31+ Years of Excellence
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className={`sticky top-0 z-50 bg-white transition-shadow duration-300 ${isScrolled ? 'shadow-lg' : 'shadow-md'}`}>
        <div className="container mx-auto px-6 py-4">
          <div className="flex justify-between items-center">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <img 
                src="/header-logo.png" 
                alt="D P Sarda & Co. - Chartered Accountants"
                className="h-16 md:h-20 object-contain"
              />
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-8">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`font-medium transition-colors ${
                    location.pathname === item.path
                      ? 'text-emerald'
                      : 'text-gray-700 hover:text-emerald'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <Link to="/contact">
                <Button className="bg-gold hover:bg-gold/90 text-navy px-6 py-2 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg">
                  Get Consultation
                </Button>
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden text-navy"
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>

          {/* Mobile Navigation */}
          {isOpen && (
            <div className="lg:hidden mt-4 pb-4 border-t pt-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsOpen(false)}
                  className={`block py-3 font-medium transition-colors ${
                    location.pathname === item.path
                      ? 'text-emerald'
                      : 'text-gray-700 hover:text-emerald'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <Link to="/contact" onClick={() => setIsOpen(false)}>
                <Button className="w-full mt-4 bg-gold hover:bg-gold/90 text-navy px-6 py-2 rounded-lg">
                  Get Consultation
                </Button>
              </Link>
            </div>
          )}
        </div>
      </nav>
    </>
  );
};

export default Navigation;